/**
 * Issue / Risk tracker status — single source of truth.
 */

import { createStatusHelpers } from "./statusHelpers";

export const RISK_STATUS = {
  OPEN: "Open",
  IN_PROGRESS: "In Progress",
  UNDER_REVIEW: "Under Review",
  MITIGATED: "Mitigated",
  CLOSED: "Closed",
  OVERDUE: "Overdue",
} as const;

export type RiskStatusValue = (typeof RISK_STATUS)[keyof typeof RISK_STATUS];

const helpers = createStatusHelpers(RISK_STATUS, RISK_STATUS.OPEN);

export const RISK_STATUS_VALUES = helpers.VALUES;
export const tryNormalizeRiskStatus = helpers.tryNormalize;
export const normalizeRiskStatus = helpers.normalize;
export const isRiskStatus = helpers.isStatus;
export const isAnyRiskStatus = helpers.isAnyStatus;

export const QMS_STATUS = {
  OPEN: "Open",
  IN_PROGRESS: "In Progress",
  PENDING_REVIEW: "Pending Review",
  CLOSED: "Closed",
} as const;

export type QmsStatusValue = (typeof QMS_STATUS)[keyof typeof QMS_STATUS];

const qmsHelpers = createStatusHelpers(QMS_STATUS, QMS_STATUS.OPEN);

export const QMS_STATUS_VALUES = qmsHelpers.VALUES;
export const tryNormalizeQmsStatus = qmsHelpers.tryNormalize;
export const normalizeQmsStatus = qmsHelpers.normalize;
export const isQmsStatus = qmsHelpers.isStatus;
export const isAnyQmsStatus = qmsHelpers.isAnyStatus;
